import { memo } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "@mui/icons-material";

import AppBreadcrumbsDto from "dto/components/app-breadcrumbs-dto";

const AppBreadcrumbs = ({ items = [] }: AppBreadcrumbsDto) => {
	const breadcrumbItems = items || [];

	if (breadcrumbItems.length === 0) return null;

	return (
		<div className="app-breadcrumbs">
			<nav className="breadcrumbs">
				<ol className="breadcrumbs__list">
					{breadcrumbItems.map((item, index) => (
						<li key={item.href || index} className="breadcrumbs__item">
							{index > 0 && <ChevronRight className="breadcrumbs__separator" />}

							{index === breadcrumbItems.length - 1 ? (
								<span className="breadcrumbs__current">{item.label}</span>
							) : (
								/* prettier-ignore */
								<Link to={item.href} className="breadcrumbs__link">{item.label}</Link>
							)}
						</li>
					))}
				</ol>
			</nav>
		</div>
	);
};

export default memo(AppBreadcrumbs);
